export const SAVE_DOCS_FORM_DATA = "SAVE_DOCS_FORM_DATA";
export const SAVE_REFIDOCS_FORM_DATA = "SAVE_REFIDOCS_FORM_DATA";
export const SUBMIT_DOC = "SUBMIT_DOC";
export const SUBMIT_DOC_SUCCESS = "SUBMIT_DOC_SUCCESS";
export const SUBMIT_DOC_FAILED = "SUBMIT_DOC_FAILED";
export const SUBMIT_REFIDOC = "SUBMIT_REFIDOC";
export const SUBMIT_REFIDOC_SUCCESS = "SUBMIT_REFIDOC_SUCCESS";
export const SUBMIT_REFIDOC_FAILED = "SUBMIT_REFIDOC_FAILED";
export const CLEAR_DOCS_ERROR = "CLEAR_DOCS_ERROR";
export const FEES_ERROR = "FEES_ERROR";
export const CLEAR_MULTI_FORM_FEES_ERROR = "CLEAR_MULTI_FORM_FEES_ERROR";
export const DOWNLOAD_ALL = "DOWNLOAD_ALL";
export const DOWNLOAD_ALL_SUCCESS = "DOWNLOAD_ALL_SUCCESS";
export const DOWNLOAD_ALL_FAILED = "DOWNLOAD_ALL_FAILED";
export const GET_LIEN_HOLDER_INFO = "GET_LIEN_HOLDER_INFO";
export const CLEAR_DOCS_RESPONSE = "CLEAR_DOCS_RESPONSE";
